<template>
    <div id="voucher">
        <media-only desktop>
            <Teaser :backgroundUrl="teaser.imageUrl" :gift-box-banner-visible="product.giftBoxBannerVisible" />
        </media-only>
        <media-only mobile>
            <ImageSwiper :images="productDetails.images" />
        </media-only>

        <LayoutWithAside over-teaser sticky-aside>
            <template v-slot:main>
                <DetailsSection>
                    <h1 class="main-title">{{ productDetails.title }}</h1>
                    <AdditionalDescription
                        v-if="productDetails.additionalDescription"
                        :descriptionHtml="productDetails.additionalDescription"
                    ></AdditionalDescription>
                </DetailsSection>

                <DetailsSection v-if="$getSafe(productDetails, 'services.length')">
                    <template slot="header">Freue dich auf</template>
                    <CheckList :items="productDetails.services" />
                </DetailsSection>

                <DetailsSection v-if="productDetails.voucherInfos">
                    <template slot="header">Zusatzinformationen</template>
                    <DotList :items="productDetails.voucherInfos" />
                </DetailsSection>

                <DetailsSection v-if="productDetails.description">
                    <template slot="header">{{ $t('ProductDetails.section.aboutOffer') }}</template>
                    <Description :descriptionHtml="productDetails.description"> </Description>
                </DetailsSection>

                <DetailsSection>
                    <template slot="header">{{ $t('HotelAddress.term.provider') }}</template>
                    <h6 class="mb-2">Animod GmbH</h6>
                    <HotelAddress :hotelDetails="hotelDetails" />
                </DetailsSection>

                <media-only desktop>
                    <DetailsSection v-if="productDetails.images && $getSafe(productDetails, 'images.length')">
                        <template slot="header">{{ $t('ProductDetails.section.photos') }}</template>
                        <NettoImageGallery :images="productDetails.images" />
                    </DetailsSection>
                </media-only>
            </template>

            <template v-slot:aside>
                <media-only desktop>
                    <NettoProductSelect :productDetails="productDetails"></NettoProductSelect>
                </media-only>
            </template>

            <template v-slot:after>
                <media-only mobile>
                    <ProductFooter
                        ref="footer"
                        @click="showSelectionDialog = true"
                        :buttonText="buttonText"
                        class="netto-product-footer"
                    />

                    <DialogSwipe :show="showSelectionDialog" direction="bottom" @close="showSelectionDialog = false">
                        <NettoProductSelect v-if="product.voucherDetails" :product-details="voucherDetails" />
                    </DialogSwipe>
                </media-only>
            </template>
        </LayoutWithAside>
    </div>
</template>

<script>
import ProductDetailsDesktop from '@/components/product/ProductDetailsDesktop';
import NettoProductSelect from '@/themes/nettovorteilswelt/components/product/NettoProductSelect';
import NettoImageGallery from '@/themes/nettovorteilswelt/components/product/NettoImageGallery';
import ImageSwiper from '@/components/swiper/ImageSwiper';
import ProductFooter from '@/components/mobile/ProductFooterMobile';
import DialogSwipe from '@/components/mobile/DialogSwipe';
import formatPrice from '@/filters/formatPrice';
import productStickyFooter from '~/mixins/injectStickyFooter';
import MediaOnly from '@/components/MediaOnly';
import voucherDetails from '@/pages/-voucher-details.vue';

export default {
    name: 'NettoVoucherDetails',
    extends: ProductDetailsDesktop,
    components: { MediaOnly, DialogSwipe, ProductFooter, ImageSwiper, NettoImageGallery, NettoProductSelect },
    mixins: [productStickyFooter({ offsetBottom: 0 })],
    data() {
        return {
            showSelectionDialog: false
        };
    },
    computed: {
        voucherDetails() {
            return this.product.voucherDetails;
        },
        buttonText() {
            if (this.productDetails.soldOut) {
                return 'Ausverkauft';
            }
            const price = this.$getSafe(this.productDetails, 'price.regularPriceValues.minimumPrice.price');
            if (price != null) {
                return `nur ${formatPrice(price)}`;
            }
            return $t('ProductDetails.productSelect.selectTrip');
        }
    }
};
</script>
